import type { SVGProps } from "react";

export function CloudUploadIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M10 2C12.8166 2 14.4145 3.92329 14.6469 6.24599L14.7179 6.24599C16.5306 6.24599 18 7.75792 18 9.62299C18 9.71829 17.9962 9.81267 17.9886 9.90598C17.6666 9.50435 17.2919 9.14686 16.8748 8.84404C16.5644 7.91106 15.7121 7.24599 14.718 7.24599L14.6469 7.24599C14.1332 7.24601 13.703 6.85673 13.6518 6.34554C13.4497 4.32493 12.1085 3 10 3C7.88606 3 6.55108 4.31588 6.34818 6.34547C6.29707 6.85669 5.86688 7.24601 5.3531 7.24599L5.28207 7.24599C4.02819 7.24599 3 8.30392 3 9.62299C3 10.9421 4.02819 12 5.28205 12H7.94761C7.86058 12.323 7.80097 12.6572 7.77144 13H5.28205C3.46942 13 2 11.4881 2 9.62299C2 7.82009 3.3731 6.34717 5.10199 6.25098L5.35314 6.24599C5.58687 3.90802 7.18335 2 10 2ZM13.5 9C15.9853 9 18 11.0147 18 13.5C18 15.9853 15.9853 18 13.5 18C11.0147 18 9 15.9853 9 13.5C9 11.0147 11.0147 9 13.5 9ZM15.1023 13.8977C15.3219 14.1174 15.6781 14.1174 15.8977 13.8977C16.1174 13.6781 16.1174 13.3219 15.8977 13.1023L13.8977 11.1023C13.6781 10.8826 13.3219 10.8826 13.1023 11.1023L11.1023 13.1023C10.8826 13.3219 10.8826 13.6781 11.1023 13.8977C11.3219 14.1174 11.6781 14.1174 11.8977 13.8977L13 12.7955V15.5C13 15.7761 13.2239 16 13.5 16C13.7761 16 14 15.7761 14 15.5V12.7955L15.1023 13.8977Z"
        fill={props.fill || "#242424"}
      />
    </svg>
  );
}
